export default "__VITE_ASSET__Dn7oKKWY__"